<template>
  <div class="error">
    <el-dialog
      title="错误信息"
      :visible.sync="visible"
      width="500px"
      :close-on-click-modal="false"
      class="errorDialog"
      :show-close="false"
      top="25vh"
      :lock-scroll="false"
    >
      <div class="main">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="optionsItemr" v-html="msg"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitFn">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      msg: '',
    }
  },
  methods: {
    show(msg) {
      this.msg = msg
      this.visible = true
    },
    handleSubmitFn() {
      this.visible = false
      this.$emit('error')
    },
  },
}
</script>
